import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CTA from "../components/CTA";
import BusinessContact from "../components/BusinessContact";
import { setPageSeo } from "../lib/seo";

export default function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
    setPageSeo({
      title: "Contact DevzCorner — Start Your Project",
      description:
        "Contact DevzCorner in Bengaluru for web apps, AI systems, SaaS, embedded hardware, or 3D product builds. Phone, email, and office address.",
      path: "/contact",
    });
  }, []);

  return (
    <main className="relative bg-ink-0 text-white min-h-screen flex flex-col">
      <Navbar />
      <div className="flex-grow pt-28 pb-8 px-6 md:px-10 max-w-7xl mx-auto w-full">
        <BusinessContact />
      </div>
      <div className="flex-grow">
        <CTA />
      </div>
      <Footer />
    </main>
  );
}
